import { CreditCard, Home, PackagePlus, ReceiptText } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DataTable from "../../components/DataTable";
import StatusBadge from "../../components/StatusBadge";
import { api } from "../../lib/api";
import { AdminCard, AdminHeader } from "./AdminShell";

export default function Dashboard() {
  const [data, setData] = useState<any>({});
  useEffect(() => { api("/api/admin/dashboard").then(setData).catch(() => undefined); }, []);
  const statusMap = Object.fromEntries((data.byStatus || []).map((row: any) => [row.status, row.count]));
  const cards = [
    ["Today Orders", data.summary?.today_orders || 0],
    ["Today Sales", `$${Number(data.summary?.today_sales || 0).toFixed(2)}`],
    ["Pending Payment", statusMap.pending_payment || 0],
    ["Payment Submitted", data.payments?.count || statusMap.payment_submitted || 0],
    ["Paid Orders", statusMap.paid || 0],
    ["Shipped Orders", statusMap.shipped || 0],
    ["Products", data.products?.total_products || 0],
    ["Low Stock", data.products?.low_stock || 0]
  ];
  return (
    <div>
      <AdminHeader title="Dashboard" description="A focused single-store command center for products, orders, manual payments, shipping, and homepage updates." />
      <div className="grid gap-4 md:grid-cols-4">{cards.map(([label, value]) => <AdminCard key={label as string}><p className="text-sm font-bold text-slate-500">{label}</p><p className="mt-2 text-3xl font-black">{value}</p></AdminCard>)}</div>
      <div className="mt-6 grid gap-4 md:grid-cols-4">
        <Link className="btn-primary" to="/admin/products/new"><PackagePlus size={16} className="mr-2" />Add Product</Link>
        <Link className="btn-secondary" to="/admin/payment-methods"><CreditCard size={16} className="mr-2" />Add Payment</Link>
        <Link className="btn-secondary" to="/admin/homepage"><Home size={16} className="mr-2" />Homepage</Link>
        <Link className="btn-secondary" to="/admin/orders"><ReceiptText size={16} className="mr-2" />Orders</Link>
      </div>
      <div className="mt-6 grid gap-6 xl:grid-cols-2">
        <AdminCard title="Recent Orders"><DataTable rows={(data.recentOrders || []) as Record<string, unknown>[]} columns={[{ key: "order_no", label: "Order" }, { key: "name", label: "Customer" }, { key: "total", label: "Total" }, { key: "status", label: "Status", render: (row) => <StatusBadge status={String(row.status)} /> }]} /></AdminCard>
        <AdminCard title="Recent Payment Submissions"><DataTable rows={(data.recentPayments || []) as Record<string, unknown>[]} columns={[{ key: "order_no", label: "Order" }, { key: "txid", label: "TXID" }, { key: "note", label: "Note" }, { key: "status", label: "Status", render: (row) => <StatusBadge status={String(row.status)} /> }]} /></AdminCard>
      </div>
    </div>
  );
}
